exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner[data-v-ea04e130] {\n  padding: 0 15px;\n}\n", ""]);

// exports
